export default "__VITE_ASSET__D$iE0Ckr__"